<div *ngIf="totalCount > perPage || forcedFooter">
    <nav class="pagination-wrapper" [class.floating]="fixedFooter" [class.wide]="!isFilterShown" [class.scroll]="!bottomOfPage">
      <div *ngIf="!dialog" class="flexBox">
      </div>
      <div *ngIf="!fixedFooter" class="pageDisplay" [class.left]="dialog">
        <span class="italic">{{pageDisplay}}</span>
      </div>
      <div class="separator"></div>
      <ul class="pagination">
        <li class="pagination-previous">
          <button *ngIf="1 === pageNum" mat-raised-button color="default" disabled="disabled">
              <mat-icon>chevron_left</mat-icon>
              <span l10nTranslate>Pagination.Previous</span>
          </button>
          <button *ngIf="1 != pageNum" mat-raised-button color="default" (click)="paginatePrevious()">
              <mat-icon>chevron_left</mat-icon>
              <span l10nTranslate>Pagination.Previous</span>
          </button>
        </li>
        <li>
          <button *ngIf="1 === pageNum" mat-raised-button color="primary">
            1
          </button>
          <button *ngIf="1 != pageNum" mat-raised-button color="default" (click)="paginate(1)">
            1
          </button>
        </li>
        <li *ngIf="displayFirstPage">
          <button mat-raised-button color="default" (click)="paginateFirstEllipses()">
            ...
          </button>
        </li>
        <li *ngFor="let page of pages;">
          <button *ngIf="page === pageNum" mat-raised-button color="primary">
            {{page}}
          </button>
          <button *ngIf="page != pageNum" mat-raised-button color="default" (click)="paginate(page)">
            {{page}}
          </button>
        </li>
        <li *ngIf="displayLastPage">
          <button mat-raised-button color="default" (click)="paginateLastEllipses()">
            ...
          </button>
        </li>
        <li>
          <button *ngIf="lastPage === pageNum && lastPage !== 1" mat-raised-button color="primary">
              {{lastPage}}
          </button>
          <button *ngIf="lastPage != pageNum" mat-raised-button color="default" (click)="paginate(lastPage)">
              {{lastPage}}
          </button>
        </li>
        <li class="pagination-next">
          <button *ngIf="pageNum === lastPage" mat-raised-button color="default" disabled="disabled">
            <div class="mat-button-wrapper">
            <span l10nTranslate>Pagination.Next</span>
            <mat-icon class="icon-right">chevron_right</mat-icon>
            </div>
          </button>
          <button *ngIf="pageNum != lastPage" mat-raised-button color="default" (click)="paginateNext()">
            <div class="mat-button-wrapper">
            <span l10nTranslate>Pagination.Next</span>
            <mat-icon class="icon-right">chevron_right</mat-icon>
            </div>
          </button>
        </li>
      </ul>
      <button *ngIf="displayScrollButton" mat-raised-button color="default" class="scroll-to-top" (click)="scrollToTop()">
         <div class="mat-button-wrapper">  
           <span l10nTranslate>Pagination.ScrollToTop</span>
           <mat-icon>expand_less</mat-icon>
         </div>
      </button>
    </nav>
</div>

